module.exports = __webpack_public_path__ + "static/img/li_top6.58b4b58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top6.png
// module id = NSAm
// module chunks = 1